import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { IonicModule, ModalController } from "ionic-angular";
import { CALENDAR_COMPONENTS } from "../calendar/index";
import { CalendarService } from "../../services/common/calendar/calendar.service";

@NgModule({
  imports: [IonicModule],
  declarations: CALENDAR_COMPONENTS,
  exports: CALENDAR_COMPONENTS,
  entryComponents: CALENDAR_COMPONENTS,
  providers: [CalendarService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CalendarModule {}



// WEBPACK FOOTER //
// ./src/shared/calendar/calendar.module.ts